import { useSWRConfig } from "swr";
import useSWRMutation from "swr/mutation";
import type { SWRMutationResponse } from "swr/mutation";
import { HTTP_METHODS } from "rivals/services/base";
import getFetchHeaders from "rivals/shared/utils/getFetchHeaders";

const MUTATE_KEY = "mark_user_alert_read";

async function markUserAlertRead(
  _: string,
  { arg }: { arg: number }
): Promise<void> {
  const url = `/api/v2/users/alerts/${arg}/mark_read`;

  await fetch(url, {
    headers: getFetchHeaders(),
    method: HTTP_METHODS.PUT
  });
}

export default function useMarkUserAlertRead(
  callback?: () => void
): SWRMutationResponse<void, never, string, number> {
  const { mutate } = useSWRConfig();

  const key = `mark_alert_read`;

  return useSWRMutation(key, markUserAlertRead, {
    onSuccess: function () {
      mutate(MUTATE_KEY);
      callback && callback();
    }
  });
}
